// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d8d0bf79","396":"0ea8dd58","455":"b81c6a92","977":"1b0cea5c"}[chunkId] + ".chunk.js";
};